import axios from "axios";
import React from "react";
import themeConfig from "../../configs/themeConfig";
import { getRecords } from "../Components/Datatable/store/action";
import toast from "react-hot-toast";
import { ErrorToast, getUserData } from "../../utility/Utils";
import Swal from "sweetalert2";
export const addCustomer = (customer) => {
  return (dispatch) => {
    dispatch({ type: "SET_SIDEBAR_LOADING", payload: true });
    return axios
      .post(`${themeConfig.app.apiUrl}/customer/create`, customer)
      .then(({ data }) => {
        if (!data.status) {
          dispatch({ type: "TRIGGER_VALIDATION", payload: data });
          return;
        }
        dispatch({ type: "SHOW_DRAWER", payload: false });
        dispatch(getRecords());
        toast.success("Dealership created successfully!");
      })
      .catch(function ({ response }) {
        let errors = response?.data?.errors;
        if (!errors)
          return toast(
            (t) => (
              <ErrorToast t={t} message={"Something went wrong.Try again!"} />
            ),
            { style: { minWidth: "310px" }, className: "sd-toast-wrap" }
          );

        let errorMarkUp = [];
        for (let errorKey in errors) {
          // errorMarkUp.push(<ErrorToast t={t} message={errors[errorKey]} />)
          toast((t) => <ErrorToast t={t} message={errors[errorKey]} />, {
            style: { minWidth: "310px" },
            className: "sd-toast-wrap",
          });
        }
        // toast(t => (
        //     errorMarkUp
        // ))
        // if (error.response.data.message = 'SQLSTATE[23000]') {
        //     toast(t => (
        //         <ErrorToast t={t} message={"Email should not be duplicate"} />
        //     ))
        // } else {
        //     toast(t => (
        //         <ErrorToast t={t} message={"Something went wrong.Try again!"} />
        //     ))
        // }
      })
      .finally(() => {
        dispatch({ type: "SET_SIDEBAR_LOADING", payload: false });
      });
  };
};

export const updateCustomer = (user, showRecords = true) => {
  return (dispatch) => {
    dispatch({ type: "SET_SIDEBAR_LOADING", payload: true });
    return axios
      .post(`${themeConfig.app.apiUrl}/customer/update`, user)
      .then(({ data }) => {
        if (!data.status) {
          dispatch({ type: "TRIGGER_VALIDATION", payload: data });
          return;
        }

        dispatch({ type: "SHOW_DRAWER", payload: false });
        showRecords && dispatch(getRecords());
        toast.success("Dealership update successfully!");
      })
      .catch(function ({ response }) {
        let errors = response?.data?.errors;
        if (!errors)
          return toast(
            (t) => (
              <ErrorToast t={t} message={"Something went wrong.Try again!"} />
            ),
            { style: { minWidth: "310px" }, className: "sd-toast-wrap" }
          );

        let errorMarkUp = [];
        for (let errorKey in errors) {
          // errorMarkUp.push(<ErrorToast t={t} message={errors[errorKey]} />)
          toast((t) => <ErrorToast t={t} message={errors[errorKey]} />, {
            style: { minWidth: "310px" },
            className: "sd-toast-wrap",
          });
        }
        // toast(t => (
        //     <ErrorToast t={t} message={"Something went wrong.Try again!"} />
        // ))
      })
      .finally(() => {
        dispatch({ type: "SET_SIDEBAR_LOADING", payload: false });
      });
  };
};

export const getCustomerByUser = (id) => {
  return (dispatch) => {
    dispatch({ type: "SET_CUSTOMER_LOADING", payload: true });
    return axios
      .get(`${themeConfig.app.apiUrl}/customer/detail/${id}`)
      .then(({ data }) => {
        data.status &&
          dispatch({ type: "SET_CUSTOMER", payload: data.records });
        return data
      })
      .catch(function (error) {
        toast((t) => (
          <ErrorToast t={t} message={"Something went wrong.Try again!"} />
        ));
      })
      .finally(() => {
        dispatch({ type: "SET_CUSTOMER_LOADING", payload: false });
      });
  };
};

export const alterNativeUrl = () => {
  return axios
    .get(`${themeConfig.app.apiUrl}/customer/detail/${id}`)
    .then(({ data }) => {

    })
    .catch(function (error) {
      toast((t) => (
        <ErrorToast t={t} message={"Something went wrong.Try again!"} />
      ));
    })
    .finally(() => {

    });
};

export const openEditCustomer = (num, parent_id, is_child = false) => {
  return (dispatch, state) => {
    const { records } = state().datatable;
    const { userData } = state().auth;

    let row;

    // row = userData?.user_role?.id === 1 ? (parent_id === null ? records.find((e, index) => e.id === num) : records.find(el => el.user.id === parent_id).sub_customer.find(ce => ce.id === num)) : records.find((e, index) => e.id === num)
    row =
      userData?.user_role?.id === 1
        ? parent_id === null || is_child
          ? records.find((e, index) => e.id === num)
          : records
            .find((el) => el.user.id === parent_id)
            ?.sub_customer.find((ce) => ce.id === num)
        : records.find((e, index) => e.id === num);

    dispatch({ type: "SET_DRAWER_EDIT_ROW", payload: row });
    dispatch({ type: "SHOW_DRAWER", payload: true });
  };
};

export const disableCustomer = (num) => {
  return async (dispatch) => {
    dispatch({ type: "SET_CUSTOMER_LOADING", payload: true });
    return axios
      .get(`${themeConfig.app.apiUrl}/customer/disable/${num}`)
      .then(({ data }) => {
        toast.success(data?.msg);
        dispatch(getRecords());
        dispatch({ type: "SET_CUSTOMER_LOADING", payload: false });
      })
      .finally(() =>
        dispatch({ type: "SET_CUSTOMER_LOADING", payload: false })
      );
  };
};
export const dealerShipUsers = (user) => {
  return (dispatch, state) => {
    dispatch({ type: "SET_DEALERSHIPS_USERS", payload: user });
  };
};

export const deleteCustomer = (id) => {
  return (dispatch) => {
    return axios
      .get(`${themeConfig.app.apiUrl}/customer/delete/${id}`)
      .then((response) => {
        dispatch(getRecords());
        Swal.fire("Customer deleted successful!", "", "success");
      })
      .catch(function (error) {
        toast((t) => (
          <ErrorToast t={t} message={"Something went wrong.Try again!"} />
        ));
      })
      .finally(() => {
        dispatch({ type: "SET_CUSTOMER_LOADING", payload: false });
      });
  };
};

export const toggleStatus = (id) => {
  return (dispatch) => {
    return axios
      .get(`${themeConfig.app.apiUrl}/customer/status/update/${id}`)
      .then((response) => {
        Swal.fire({
          title: "Status updated!",
          icon: "success",
        });
        dispatch(getRecords());
      })
      .catch(function (error) {
        toast((t) => (
          <ErrorToast t={t} message={"Something went wrong.Try again!"} />
        ));
      })
      .finally(() => {
        dispatch({ type: "SET_CUSTOMER_LOADING", payload: false });
      });
  };
};

/* export const addUserSetting = (customer) => {
    return dispatch => {
        dispatch({ type: 'SET_SIDEBAR_LOADING', 'payload': true });
        return axios.post(`${themeConfig.app.apiUrl}/customer/create`, customer)
            .then(({data}) => {
                if(!data.status) {
                    dispatch({ type: "TRIGGER_VALIDATION", payload: data});
                    return;
                }
                dispatch({ type: "SHOW_DRAWER", payload: false });
                dispatch(getRecords());
                toast.success("Dealership created successfully!")
            }).catch(function (error) {
                if (error.response.data.message = 'SQLSTATE[23000]') {
                    toast(t => (
                        <ErrorToast t={t} message={"Email should not be duplicate"} />
                    ))
                } else {
                    toast(t => (
                        <ErrorToast t={t} message={"Something went wrong.Try again!"} />
                    ))
                }
            }).finally(() => {
                dispatch({ type: 'SET_SIDEBAR_LOADING', 'payload': false });
            })
    }
} */

export const updateUserSetting = (user, showRecords = true) => {
  return (dispatch) => {
    dispatch({ type: "SET_SIDEBAR_LOADING", payload: true });
    return axios
      .post(`${themeConfig.app.apiUrl}/setting/user`, user)
      .then(({ data }) => {
        if (!data.status) {
          dispatch({ type: "TRIGGER_VALIDATION", payload: data });
          return;
        }
        dispatch({ type: "SHOW_DRAWER", payload: false });
        showRecords && dispatch(getRecords());
        toast.success("User update successfully!");
      })
      .catch(function ({ response }) {
        toast((t) => (
          <ErrorToast
            t={t}
            message={response?.data?.msg || "Something went wrong.Try again!"}
          />
        ));
      })
      .finally(() => {
        dispatch({ type: "SET_SIDEBAR_LOADING", payload: false });
      });
  };
};

export const handleDisclaimer = (disclaimer, websiteUrl) => {
  return (dispatch) => {
    return axios
      .post(`${themeConfig.app.apiUrl}/store/disclaimer`, { disclaimer: disclaimer, website_url: websiteUrl })
      .then(({ data }) => {
        if (!data.status) {
          // dispatch({ type: "TRIGGER_VALIDATION", payload: data });
          return;
        }
        // dispatch({ type: "SHOW_DRAWER", payload: false });
        // showRecords && dispatch(getRecords());
        toast.success(data.message);
      })
      .catch(function ({ response }) {
        toast((t) => (
          <ErrorToast
            t={t}
            message={response?.data?.msg || "Something went wrong.Try again!"}
          />
        ));
      })
      .finally(() => {
        // dispatch({ type: "SET_SIDEBAR_LOADING", payload: false });
      });
  };
};

export const getDisclaimer = (store) => {
  return (dispatch) => {
    return axios
      .get(`${themeConfig.app.apiUrl}/get/disclaimer`)
      .then(({ data }) => {
        if (!data.status) {
          return;
        }
        return data;
      })
      .catch(function ({ response }) {
        toast((t) => (
          <ErrorToast
            t={t}
            message={response?.data?.msg || "Something went wrong.Try again!"}
          />
        ));
      })
      .finally(() => {
        // dispatch({ type: "SET_SIDEBAR_LOADING", payload: false });
      });
  };
};

export const blockCustomer = (payload = null) => {
  return async (dispatch) => {
    return await axios.post(
      `${themeConfig.app.apiUrl}/customer/block`,
      payload
    );
  };
};

export const handleAllownces = (
  type = "get",
  id = 0,
  payload = null,
  isDefault = false
) => {
  return (dispatch) => {
    // dispatch({ type: 'SET_CUSTOMER_LOADING', 'payload': true });
    const route = isDefault
      ? `/default/allowance`
      : `/customer/allowance/${id}`;
    return axios[type](`${themeConfig.app.apiUrl + route}`, payload)
      .then(({ data }) => {
        return data;
      })
      .catch(function (error) {
        toast((t) => (
          <ErrorToast t={t} message={"Something went wrong.Try again!"} />
        ));
      })
      .finally(() => {
        // dispatch({ type: 'SET_CUSTOMER_LOADING', 'payload': false });
      });
  };
};

export const getModelList = () => {
  return async (dispatch) => {
    try {
      const { data } = await axios.get(`${themeConfig.app.apiUrl}/get/models`);
      return data?.drilldown
    } catch (error) {}
  };
}

export const getModelAllowances = (payload) => {
  return async (dispatch) => {
    try {
      const { data } = await axios.post(`${themeConfig.app.apiUrl}/get/model/allowance`, payload);
      return data
    } catch (error) {}
  };
}

export const resetPassword = (payload) => {
  return async (dispatch) => {
    try {
      const { data } = await axios.post(`${themeConfig.app.apiUrl}/user/password-reset`, payload);
      if(data?.status === true){
        return toast.success(data?.message)
      }else{
        toast((t) => (
          <ErrorToast t={t} message={'Something went wrong!'} />
        ));
      }
    } catch (error) {
      toast((t) => (
        <ErrorToast t={t} message={'Something went wrong!'} />
      ));
    }
  };
}

export const getCustomerList = (customer_id) => {
  // return;
  return async (dispatch) => {
    try {
      const { data } = await axios.get(
        `${themeConfig.app.apiUrl}/customer/subcustomer/list/${customer_id ? customer_id : "null"
        }`
      );

      if (data?.records) {
        const dealershipUsers = [
          ...data?.records.customers?.flatMap(({ value, label, tools , parent_id , domain_url, status }) => ({
            value,
            label,
            info: "Dealership",
            tools,
            userRole: 4,
            domain_url,
            parent_id,
            status
          })),
          ...data?.records.subcustomers?.flatMap(({ value, label, tools , parent_id , domain_url, status }) => ({
            value,
            label,
            info: "Subdealership",
            tools,
            userRole: 6,
            domain_url,
            parent_id,
            status
          })),
        ];
        dispatch({ type: "SET_DEALERSHIP", payload: dealershipUsers });
        return dealershipUsers;
      }
    } catch (error) {
      // Handle error if needed
    }
  };
};
